/* eslint-disable no-irregular-whitespace */
<template>
  <div class="c-box mb-16 mt-px p-menu">
    <section class="mt-8 mb-4">
      <div class="menu-main-content">
        <!-- 風呂 -->
        <template v-if="bathtubType || bathtubQuality || bathtubType">
          <a-card class="card my-5">
            <SectionContentTitle
              lineType="h-line"
              class="title-bold"
              titleContent="風呂"
            />
            <div class="ten-item px-6">
              <template v-if="bathtubType && bathtubType.equipServDetail2">
                <div
                  v-for="(el1, index1) in bathtubType.equipServDetail2"
                  :key="`bath-type-${index1}`"
                >
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010101'"
                  >
                    <div class="title-bath">温泉</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010102'"
                  >
                    <div class="title-bath">大浴場</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010103'"
                  >
                    <div class="title-bath">露天風呂</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010104'"
                  >
                    <div class="title-bath">サウナ</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010105'"
                  >
                    <div class="title-bath">家族風呂</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010106'"
                  >
                    <div class="title-bath">天然温泉</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010107'"
                  >
                    <div class="title-bath">人工温泉</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010108'"
                  >
                    <div class="title-bath">ジャグジー</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010109'"
                  >
                    <div class="title-bath">水風呂</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                  <div
                    class="flex border justify-between"
                    v-if="el1 && el1.equipServCd2 === 'A10010110'"
                  >
                    <div class="title-bath">岩盤浴</div>
                    <div
                      class="content-bath"
                      v-if="isShow(el1.equipServValue2)"
                    >
                      ○
                    </div>
                    <div class="content-bath" v-else>×</div>
                  </div>
                </div>
              </template>
            </div>

            <template v-if="bathtubQuality && bathtubQuality.equipServDetail2">
              <div class="flex pt-3 px-6 flex-wrap">
                <span class="pr-3">[泉質]</span>
                <span
                  v-for="(el3, index3) in bathtubQuality.equipServDetail2"
                  :key="`bath-type-${index3}`"
                >
                  <span
                    class="pr-3"
                    v-if="
                      el3 &&
                      el3.equipServNm2 &&
                      isShow(el3.equipServValue2)
                    "
                  >
                    {{ el3.equipServNm2 }}
                  </span>
                </span>
              </div>
            </template>

            <template v-if="bathtubEfficiency && bathtubEfficiency.equipServDetail2">
              <div class="flex pt-3 px-6 flex-wrap">
                <span class="pr-3">[効能]</span>
                <span
                  v-for="(el4, index4) in bathtubEfficiency.equipServDetail2"
                  :key="`bath-type-${index4}`"
                >
                  <span
                    class="pr-3"
                    v-if="
                      el4 &&
                      el4.equipServNm2 &&
                      isShow(el4.equipServValue2)
                    "
                  >
                    {{ el4.equipServNm2 }}
                  </span>
                </span>
              </div>
            </template>
          </a-card>
        </template>
        <!-- 食事場所 -->

        <template v-if="breakfast || dinner">
          <a-card class="card my-5">
            <SectionContentTitle
              lineType="h-line"
              class="title-bold"
              titleContent="食事場所"
            />
            <template v-if="breakfast && breakfast.equipServDetail2">
              <div class="px-6">
                <div class="flex flex-wrap">
                  <span class="pr-3">[朝食]</span>
                  <span
                    v-for="(el5, index5) in breakfast.equipServDetail2"
                    :key="`bath-type-${index5}`"
                  >
                    <span
                      class="pr-3"
                      v-if="
                        el5 &&
                        el5.equipServNm2 &&
                        isShow(el5.equipServValue2)
                      "
                    >
                      {{ el5.equipServNm2 }}
                    </span>
                  </span>
                </div>
              </div>
            </template>

            <template v-if="dinner && dinner.equipServDetail2">
              <div class="px-6">
                <div class="flex flex-wrap">
                  <span class="pr-3">[夕食]</span>
                  <span
                    v-for="(el6, index6) in dinner.equipServDetail2"
                    :key="`bath-type-${index6}`"
                  >
                    <span
                      class="pr-3"
                      v-if="
                        el6 &&
                        el6.equipServNm2 &&
                        isShow(el6.equipServValue2)
                      "
                    >
                      {{ el6.equipServNm2 }}
                    </span>
                  </span>
                </div>
              </div>
            </template>
          </a-card>
        </template>
        <!-- 部屋設備・備品 -->
        <template v-if="equipmentProduct && equipmentProduct.equipServDetail2">
          <a-card class="card my-5">
            <SectionContentTitle
              lineType="h-line"
              class="title-bold"
              titleContent="部屋設備・備品"
            />
            <div class="grid grid-cols-2 px-6">
              <span
                v-for="(el7, index7) in equipmentProduct.equipServDetail2.filter(
                  (el7) => el7 && isShow(el7.equipServValue2)
                )"
                :key="`bath-type-${index7}`"
              >
                <span>
                  <span class="pr-3">
                    {{ el7.equipServNm2 }}
                  </span>
                </span>
              </span>
            </div>
          </a-card>
        </template>

        <!-- 館内設備 -->
        <template v-if="facilitiesHall && facilitiesHall.equipServDetail2">
          <a-card class="card my-5">
            <SectionContentTitle
              lineType="h-line"
              class="title-bold"
              titleContent="館内設備"
            />
            <div class="grid grid-cols-2 px-6">
              <span
                v-for="(el8, index8) in facilitiesHall.equipServDetail2.filter(
                  (el8) => el8 && isShow(el8.equipServValue2)
                )"
                :key="`bath-type-${index8}`"
              >
                <span>
                  <span class="pr-3">
                    {{ el8.equipServNm2 }}
                  </span>
                </span>
              </span>
            </div>
          </a-card>
        </template>

        <!-- バリアフリー -->
        <template v-if="barrierFree && barrierFree.equipServDetail2">
          <a-card class="card my-5">
            <SectionContentTitle
              lineType="h-line"
              class="title-bold"
              titleContent="バリアフリー"
            />
            <div class="grid grid-cols-2 px-6">
              <span
                v-for="(el9, index9) in barrierFree.equipServDetail2.filter(
                  (el9) => el9 && isShow(el9.equipServValue2)
                )"
                :key="`bath-type-${index9}`"
              >
                <span class="pr-3">
                  {{ el9.equipServNm2 }}
                </span>
              </span>
            </div>
          </a-card>
        </template>

        <!-- クレジットカード -->
        <template v-if="creditCard && creditCard.equipServDetail2">
          <a-card class="card my-5">
            <SectionContentTitle
              lineType="h-line"
              class="title-bold"
              titleContent="クレジットカード"
            />
            <div class="grid grid-cols-2 px-6">
              <span
                v-for="(el10, index10) in creditCard.equipServDetail2.filter(
                  (el10) => el10 && isShow(el10.equipServValue2)
                )"
                :key="`bath-type-${index10}`"
              >
                <span class="pr-3">
                  {{ el10.equipServNm2 }}
                </span>
              </span>
            </div>
          </a-card>
        </template>

        <!-- その他サービス -->
        <template v-if="otherService.length > 0">
          <a-card class="card my-5">
            <SectionContentTitle
              lineType="h-line"
              class="title-bold"
              titleContent="その他サービス"
            />
            <div class="grid grid-cols-2 px-6">
              <span
                v-for="(el11, index11) in otherService.filter(
                  (el11) => el11 && isShow(el11.equipServValue2)
                )"
                :key="`bath-type-${index11}`"
              >
                <span class="pr-3">
                  {{ el11.equipServNm2 }}
                </span>
              </span>
            </div>
          </a-card>
        </template>

        <!-- 周辺施設 -->
        <template v-if="peripherals && peripherals.equipServDetail2">
          <a-card class="card my-5">
            <SectionContentTitle
              lineType="h-line"
              class="title-bold"
              titleContent="周辺施設"
            />
            <div class="grid grid-cols-2 px-6">
              <span
                v-for="(el12, index12) in peripherals.equipServDetail2.filter(
                  (el12) => el12 && isShow(el12.equipServValue2)
                )"
                :key="`bath-type-${index12}`"
              >
                <span class="pr-3">
                  {{ el12.equipServNm2 }}
                </span>
              </span>
            </div>
          </a-card>
        </template>

        <!-- 周辺施設 -->
        <template v-if="infectionControl.length > 0">
          <a-card class="card my-5">
            <SectionContentTitle
              lineType="h-line"
              class="title-bold"
              titleContent="感染対策について"
            />
            <div class="grid grid-cols-2 px-6">
              <span
                v-for="(el13, index13) in infectionControl"
                :key="`bath-type-${index13}`"
              >
                <span
                  class="pr-3"
                  v-if="el13 && isShow(el13.equipServValue2)"
                >
                  {{ el13.equipServNm2 }}
                </span>
              </span>
            </div>
          </a-card>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import _ from 'lodash'
import { SectionContentTitle } from '@/components/compound'
import { GET_SERVICE_DETAIL } from '@/store/modules/service/actions.js'

export default {
  components: {
    SectionContentTitle
  },
  data() {
    return {
      latitude: null,
      longitude: null,
      dataService: {},
      objSubHeader: {},
      menuNm: null,
      breadcrumb_data: [
        'トップ',
        '旅・宿泊',
        '国内宿泊',
        '宿泊施設名宿泊施設名宿泊施設名'
      ],
      open: false,
      bathtubType: null,
      bathtubQuality: null,
      bathtubEfficiency: null,
      breakfast: null,
      dinner: null,
      equipmentProduct: null,
      facilitiesHall: null,
      barrierFree: null,
      creditCard: null,
      otherService: [],
      peripherals: null,
      infectionControl: []
    }
  },
  mounted() {
    const { menuNo } = this.$route.params
    this.$store.dispatch(GET_SERVICE_DETAIL, menuNo).then((data) => {
      if (data !== null) {
        data.forEach((elementParent) => {
          elementParent.equipServDetail1.forEach((element) => {
            if (element.equipServCd1 === 'A100101') {
              const equipServCd2Set = new Set(
                element.equipServDetail2.map((item) => {
                  return item.equipServCd2
                })
              )
              const equipServCd2SetConstant = new Set([
                'A10010101',
                'A10010102',
                'A10010103',
                'A10010104',
                'A10010105',
                'A10010106',
                'A10010107',
                'A10010108',
                'A10010109',
                'A10010110'
              ])

              equipServCd2SetConstant.forEach((element2) => {
                if (!equipServCd2Set.has(element2)) {
                  element.equipServDetail2.push({
                    equipServCd2: element2,
                    equipServValues2: null,
                    equipServValue2: '×',
                    equipServNm2: ''
                  })
                }
              })

              element.equipServDetail2.sort((a, b) => {
                if (a.equipServCd2 < b.equipServCd2) {
                  return -1
                }
                if (a.equipServCd2 > b.equipServCd2) {
                  return 1
                }
                return 0
              })
              this.bathtubType = element
            }
            if (element.equipServCd1 === 'A100102') {
              this.bathtubQuality = element
            }
            if (element.equipServCd1 === 'A100103') {
              this.bathtubEfficiency = element
            }
            if (element.equipServCd1 === 'A100201' && element.equipServNm1 === '朝食') {
              this.breakfast = element
            }
            if (element.equipServCd1 === 'A100202') {
              this.dinner = element
            }
            if (element.equipServCd1 === 'A100301') {
              this.equipmentProduct = element
            }
            if (element.equipServCd1 === 'A100401') {
              this.facilitiesHall = element
            }
            if (element.equipServCd1 === 'A100404') {
              this.barrierFree = element
            }
            if (element.equipServCd1 === 'A100601') {
              this.creditCard = element
            }
            if (
              element.equipServCd1 === 'A100402' ||
              element.equipServCd1 === 'A100403'
            ) {
              this.otherService = this.otherService.concat(element.equipServDetail2)
            }
            if (element.equipServCd1 === 'A100501') {
              this.peripherals = element
            }

            const infectionControlCd1SetConstant = new Set([
              '20000000000',
              '20000000001',
              '20000000002',
              '20000000003',
              '20000000004',
              '20000000005',
              '20000000006',
              '20000000007',
              '20000000008',
              '20000000009'
            ])
            if (infectionControlCd1SetConstant.has(element.equipServCd1)) {
              this.infectionControl = this.infectionControl.concat(
                element.equipServDetail2
              )
              this.infectionControl = this.infectionControl.filter(
                (item) => this.isShow(item.equipServValue2)
              )
            }
          })
        })
      }
    })
  },
  computed: {},
  methods: {
    getEquipServValue(item) {
      return item.equipServValue2 ? item.equipServValue2 : ''
    },
    /**
     * 設備を表示するかの判定
     * @param val {string} 設備サービス値
     * @return {boolean} 表示ならtrue
     */
    isShow(val) {
      // TODO MNからは○〇の2パターンが返ってきている可能性があるため、
      // MNの設計レベルでおかしく、本来はtrue/falseであるべき
      // 暫定対応として、「まる」で変換できる３種類の丸と比較しておく
      // https://typetalk.com/topics/322409/posts/96353151
      return val && (val == '〇' || val == '○' || val == '◯');
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
